export const ORDR_FORMS: any[] = [
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "billingAccountId", "billingAccountMaxAmount", "statusId" ]
        } ],
        "columns" : [ {
            "name" : "paymentType",
            "title" : "Payment Method Type"
        }, {
            "name" : "billingAccountId",
            "title" : "Nbr"
        }, {
            "name" : "billingAccountMaxAmount",
            "title" : "Max Amount"
        }, {
            "name" : "statusId",
            "title" : "Status"
        } ],
        "formName" : "BillingAccountOrderPaymentInfo",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "list",
        "fields" : [ {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "paymentType",
            "description" : "AccountingBillingAccount",
            "style" : "",
            "id" : "BillingAccountOrderPaymentInfo_paymentType",
            "title" : "Payment Method Type",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "billingAccountId",
            "description" : "",
            "style" : "",
            "id" : "BillingAccountOrderPaymentInfo_billingAccountId",
            "title" : "Nbr",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "billingAccountMaxAmount",
            "description" : "$0.00",
            "style" : "",
            "id" : "BillingAccountOrderPaymentInfo_billingAccountMaxAmount",
            "title" : "Max Amount",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "statusId",
            "description" : "",
            "style" : "",
            "id" : "BillingAccountOrderPaymentInfo_statusId",
            "title" : "Status",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "companyNameOnCard", "titleOnCard", "firstNameOnCard", "lastNameOnCard", "cardNumber", "cardType", "expireDate", "statusId" ]
        } ],
        "columns" : [ {
            "name" : "companyNameOnCard",
            "title" : "Company Name OnCard"
        }, {
            "name" : "titleOnCard",
            "title" : "Title On Card"
        }, {
            "name" : "firstNameOnCard",
            "title" : "First Name On Card"
        }, {
            "name" : "lastNameOnCard",
            "title" : "Last Name On Card"
        }, {
            "name" : "cardNumber",
            "title" : "Card Number"
        }, {
            "name" : "cardType",
            "title" : "Card Type"
        }, {
            "name" : "expireDate",
            "title" : "Expire Date"
        }, {
            "name" : "statusId",
            "title" : "Payment Status"
        },{
            "name" : "maxAmount",
            "title" : "Max Ampount"
        }  ],
        "formName" : "CreditCardOrderPaymentInfo",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "list",
        "fields" : [ {
            name:"creditCard",
            title:"Credit Card",
            type:"COMPOSITE",
            innerFields:[
                {
                    "name" : "companyNameOnCard",
                    "title" : "Company Name OnCard"
                }, {
                    "name" : "titleOnCard",
                    "title" : "Title On Card"
                }, {
                    "name" : "firstNameOnCard",
                    "title" : "First Name On Card"
                }, {
                    "name" : "lastNameOnCard",
                    "title" : "Last Name On Card"
                }, {
                    "name" : "cardNumber",
                    "title" : "Card Number"
                }, {
                    "name" : "cardType",
                    "title" : "Card Type"
                }, {
                    "name" : "expireDate",
                    "title" : "Expire Date"
                }, {
                    "name" : "statusId",
                    "title" : "Payment Status"
                },{
                    "name" : "maxAmount",
                    "title" : "Max Ampount"
                }  
            ]
        },{
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "companyNameOnCard",
            "description" : "",
            "style" : "",
            "id" : "CreditCardOrderPaymentInfo_companyNameOnCard",
            "title" : "Company Name OnCard",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "titleOnCard",
            "description" : "",
            "style" : "",
            "id" : "CreditCardOrderPaymentInfo_titleOnCard",
            "title" : "Title On Card",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "firstNameOnCard",
            "description" : "",
            "style" : "",
            "id" : "CreditCardOrderPaymentInfo_firstNameOnCard",
            "title" : "First Name On Card",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "lastNameOnCard",
            "description" : "",
            "style" : "",
            "id" : "CreditCardOrderPaymentInfo_lastNameOnCard",
            "title" : "Last Name On Card",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "cardNumber",
            "description" : "",
            "style" : "",
            "id" : "CreditCardOrderPaymentInfo_cardNumber",
            "title" : "Card Number",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "cardType",
            "description" : "",
            "style" : "",
            "id" : "CreditCardOrderPaymentInfo_cardType",
            "title" : "Card Type",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "expireDate",
            "description" : "",
            "style" : "",
            "id" : "CreditCardOrderPaymentInfo_expireDate",
            "title" : "Expire Date",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "statusId",
            "description" : "",
            "id" : "CreditCardOrderPaymentInfo_statusId",
            "type" : "HIDDEN",
            "title" : "Payment Status",
            "imageLocation" : ""
        }, {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "maxAmount",
            "description" : "",
            "id" : "CreditCardOrderPaymentInfo_maxAmount",
            "type" : "HIDDEN",
            "title" : "",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "companyNameOnAccount", "bankName", "routingNumber", "accountNumber" ]
        } ],
        "columns" : [ {
            "name" : "maxAmount",
            "title" : "Max Amount"
        }, {
            "name" : "companyNameOnAccount",
            "title" : "Account Name"
        }, {
            "name" : "bankName",
            "title" : "Bank Name"
        }, {
            "name" : "routingNumber",
            "title" : "Routing Number"
        }, {
            "name" : "accountNumber",
            "title" : "Account Number"
        } ],
        "formName" : "EFTOrderPaymentInfo",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "list",
        "fields" : [ {
            name:"eftAccount",
            title:"EFT Account",
            type:"COMPOSITE",
            innerFields : [ {
                "name" : "companyNameOnAccount",
                "title" : "Account Name"
            }, {
                "name" : "bankName",
                "title" : "Bank Name"
            }, {
                "name" : "routingNumber",
                "title" : "Routing Number"
            }, {
                "name" : "accountNumber",
                "title" : "Account Number"
            },{
                "name" : "maxAmount",
                "title" : "Max Amount"
            } ]
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "maxAmount",
            "description" : "",
            "style" : "",
            "id" : "EFTOrderPaymentInfo_maxAmount",
            "title" : "Max Amount",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "companyNameOnAccount",
            "description" : "",
            "style" : "",
            "id" : "EFTOrderPaymentInfo_companyNameOnAccount",
            "title" : "Account Name",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "bankName",
            "description" : "",
            "style" : "",
            "id" : "EFTOrderPaymentInfo_bankName",
            "title" : "Bank Name",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "routingNumber",
            "description" : "",
            "style" : "",
            "id" : "EFTOrderPaymentInfo_routingNumber",
            "title" : "Routing Number",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "accountNumber",
            "description" : "",
            "style" : "",
            "id" : "EFTOrderPaymentInfo_accountNumber",
            "title" : "Account Number",
            "type" : "HIDDEN",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "statusDatetime", "by" ]
        } ],
        "columns" : [ {
            "name" : "statusId",
            "title" : "Status ID"
        }, {
            "name" : "statusDatetime",
            "title" : "Status Datetime"
        }, {
            "name" : "by",
            "title" : "By"
        } ],
        "formName" : "PaymentStatuses",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "list",
        "fields" : [ {
            name:"paymentStatuses",
            title:"Payment Statuses",
            type:"COMPOSITE",
            innerFields:[ {
                "name" : "statusId",
                "title" : "Status ID"
            }, {
                "name" : "statusDatetime",
                "title" : "Status Datetime"
            }, {
                "name" : "by",
                "title" : "By"
            } ]
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "statusId",
            "description" : "",
            "style" : "",
            "id" : "PaymentStatuses_statusId",
            "title" : "Status ID",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "statusDatetime",
            "description" : "",
            "style" : "",
            "id" : "PaymentStatuses_statusDatetime",
            "title" : "Status Datetime",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "by",
            "description" : "",
            "style" : "",
            "id" : "PaymentStatuses_by",
            "title" : "By",
            "type" : "HIDDEN",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "finAccountName", "finAccountId", "maxAmount", "findAccountCode", "statusId" ]
        } ],
        "columns" : [ {
            "name" : "paymentType",
            "title" : "Payment Method Type"
        }, {
            "name" : "finAccountName",
            "title" : "Account Name"
        }, {
            "name" : "finAccountId",
            "title" : ""
        }, {
            "name" : "maxAmount",
            "title" : ""
        }, {
            "name" : "findAccountCode",
            "title" : "Account Code"
        }, {
            "name" : "statusId",
            "title" : ""
        } ],
        "formName" : "FinAccountOrderPaymentInfo",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "list",
        "fields" : [ {
            name:"finAccountOrderPaymentInfo",
            title:"Fin Account Order PaymentInfo",
            type:"COMPOSITE",
            innerFields:[ {
                "name" : "paymentType",
                "title" : "Payment Method Type"
            }, {
                "name" : "finAccountName",
                "title" : "Account Name"
            }, {
                "name" : "finAccountId",
                "title" : ""
            }, {
                "name" : "maxAmount",
                "title" : ""
            }, {
                "name" : "findAccountCode",
                "title" : "Account Code"
            }, {
                "name" : "statusId",
                "title" : ""
            } ]
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "paymentType",
            "description" : "",
            "style" : "",
            "id" : "FinAccountOrderPaymentInfo_paymentType",
            "title" : "Payment Method Type",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "finAccountName",
            "description" : "",
            "style" : "",
            "id" : "FinAccountOrderPaymentInfo_finAccountName",
            "title" : "Account Name",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "finAccountId",
            "description" : "",
            "id" : "FinAccountOrderPaymentInfo_finAccountId",
            "type" : "HIDDEN",
            "title" : "",
            "imageLocation" : ""
        }, {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "maxAmount",
            "description" : "",
            "id" : "FinAccountOrderPaymentInfo_maxAmount",
            "type" : "HIDDEN",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "findAccountCode",
            "description" : "",
            "style" : "",
            "id" : "FinAccountOrderPaymentInfo_findAccountCode",
            "title" : "Account Code",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "statusId",
            "description" : "",
            "id" : "FinAccountOrderPaymentInfo_statusId",
            "type" : "HIDDEN",
            "title" : "",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "cardNumber" ]
        } ],
        "columns" : [ {
            "name" : "maxAmount",
            "title" : "Max Amount"
        }, {
            "name" : "cardNumber",
            "title" : "Card Number"
        } ],
        "formName" : "GiftCardOrderPaymentInfo",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "list",
        "fields" : [ {
            name:"giftCard",
            title:"Gift Card",
            type:"COMPOSITE",
            innerFields:[ {
                "name" : "maxAmount",
                "title" : "Max Amount"
            }, {
                "name" : "cardNumber",
                "title" : "Card Number"
            } ]
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "maxAmount",
            "description" : "",
            "style" : "",
            "id" : "GiftCardOrderPaymentInfo_maxAmount",
            "title" : "Max Amount",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "cardNumber",
            "description" : "",
            "style" : "",
            "id" : "GiftCardOrderPaymentInfo_cardNumber",
            "title" : "Card Number",
            "type" : "HIDDEN",
            "imageLocation" : ""
        } ],
        "target" : ""

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "statusId", "maxAmount" ]
        } ],
        "columns" : [ {
            "name" : "paymentMethodTypeId",
            "title" : "Type"
        }, {
            "name" : "statusId",
            "title" : "Status"
        }, {
            "name" : "maxAmount",
            "title" : "Max Amount"
        } ],
        "formName" : "ExternalOrderPaymentInfo",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "list",
        "fields" : [ {
            name:"external",
            title:"External Third Party",
            type:"COMPOSITE",
            innerFields: [ {
                "name" : "paymentMethodTypeId",
                "title" : "Type"
            }, {
                "name" : "statusId",
                "title" : "Status"
            }, {
                "name" : "maxAmount",
                "title" : "Max Amount"
            } ]
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "paymentMethodTypeId",
            "description" : "",
            "style" : "",
            "id" : "ExternalOrderPaymentInfo_paymentMethodTypeId",
            "title" : "Type",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "statusId",
            "description" : "",
            "style" : "",
            "id" : "ExternalOrderPaymentInfo_statusId",
            "title" : "Status",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "maxAmount",
            "description" : "",
            "style" : "",
            "id" : "ExternalOrderPaymentInfo_maxAmount",
            "title" : "Max Amount",
            "type" : "DISPLAY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "partyId" ]
        } ],
        "columns" : [ {
            "name" : "roleTypeId",
            "title" : "Role Type ID"
        }, {
            "name" : "partyId",
            "title" : "Party ID"
        } ],
        "formName" : "ListOrderRoles",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "list",
        "fields" : [ {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "roleTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListOrderRoles_roleTypeId",
            "title" : "Role Type ID",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "partyId",
            "description" : "",
            "style" : "",
            "id" : "ListOrderRoles_partyId",
            "title" : "Party ID",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        } ],
        "target" : ""

    }
]
